import * as React from 'react';

import CoreLink from '../../components/core_link';
import SanitizedRender from '../../components/sanitized_render';

import { imageUploadURL } from '../../url_helpers';

export interface IProps {
  headingHtml?: string;
  subheading?: string;
  bodyHtml?: string;
  ctaText: string;
  ctaTargetHref: string;
  imageKey?: string;
  jumplinkSlug?: string;
}

export default class ImageFeature extends React.Component<IProps, null> {
  imageURI() {
    return imageUploadURL(this.props.imageKey);
  }

  getBackgroundImageStyle() {
    if (!this.props.imageKey) return null;

    return {
      style: { backgroundImage: `url('${this.imageURI()}')` },
    };
  }

  renderLinkOrImage() {
    if (this.props.ctaTargetHref) {
      return (
        <CoreLink
          className="image-feature__image"
          to={this.props.ctaTargetHref}
          {... this.getBackgroundImageStyle()}
        />
      );
    }

    return (
      <div
        className="image-feature__image"
        {... this.getBackgroundImageStyle()}
      />
    );
  }

  render() {
    return (
      <div
        className="image-feature"
        id={this.props.jumplinkSlug}
      >
        <div className="image-feature__inner">
          {this.renderLinkOrImage()}
          <div className="image-feature__text">
            <div className="image-feature__text__inner">
              {this.props.subheading &&
                <h4
                  className="image-feature__subheading"
                >
                  {this.props.subheading}
                </h4>
              }
              <SanitizedRender
                htmlTag="h3"
                className="image-feature__heading"
                html={this.props.headingHtml}
                inlineTagsOnly
                blacklistedTags={['a']}
              />
              <SanitizedRender
                htmlTag="p"
                className="image-feature__body"
                html={this.props.bodyHtml}
                inlineTagsOnly
              />
              {this.props.ctaTargetHref && this.props.ctaText &&
                <CoreLink
                  className="button button--branding"
                  to={this.props.ctaTargetHref}
                >
                  {this.props.ctaText}
                </CoreLink>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/cms/components/image_feature.tsx